import './App.css';
import Navber from './components/Navber';
import { Route, Routes } from "react-router-dom";
import Home from './page/Home';
import { useNavigate } from "react-router-dom";
import BookingRoom from './page/BookingRoom';
import Register from './page/Register';
import Login from './page/Login';
import Profile from './page/Profile';
import Mybookngs from './page/Mybookngs';
import Admin from './page/Admin';
import { useEffect } from 'react';
import Landing from './page/Landing';
function App() {

const navigate = useNavigate();
	// useEffect(() => {
	// 		if (!JSON.parse(localStorage.getItem("currentuser")).isAdmin) {
	// 			navigate("/");
	// 		}
	// }, []);


  return (
		<div className="App">
			<Navber />
			<Routes>
				<Route path="/" element={<Landing />} />
				<Route path="/home" element={<Home />} />
				<Route path="/book/:id/:fromdate/:todate" element={<BookingRoom />} />
				<Route path="/register" element={<Register />} />
				<Route path="/login" element={<Login />} />
				<Route path="/profile" element={<Profile />} />
				<Route path="/mybookngs" element={<Mybookngs />} />
				<Route path="/admin" element={<Admin />} />
			</Routes>
		</div>
	);
}

export default App;
